import { FC } from "react";
import { useModal } from "@refinedev/antd";
import { useDelete, useNavigation } from "@refinedev/core";
import { Button, Modal } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

import { errorNotification, successNotification } from "../../../helpers";

type AwardsDeleteProps = {
  id: number;
  name: string;
  type?: "page" | "table";
  dataProviderName?: string;
  resource?: string;
  redirectPath?: string;
  entityAccusative?: string;
};

export const AwardsDelete: FC<AwardsDeleteProps> = ({
  id,
  name,
  type = "table",
  dataProviderName = "awardsDataProvider",
  resource = "awards",
  redirectPath = "/awards",
  entityAccusative = "награду",
}) => {
  const { modalProps, show, close } = useModal();
  const { mutate: deleteMutate } = useDelete();
  const { push } = useNavigation();

  const handleDelete = () => {
    deleteMutate({
      dataProviderName,
      resource,
      id: "",
      meta: {
        id,
      },
      ...successNotification({
        successData: {
          message: `«${name}» успешно удалено`,
          type: "success",
        },
        callback: () => {
          close();
          push(redirectPath);
        },
      }),
      ...errorNotification({}),
    });
  };

  return (
    <>
      {type === "table" ? (
        <Button
          size={"small"}
          danger
          onClick={show}
          block
          icon={<DeleteOutlined />}
        >
          Удалить
        </Button>
      ) : (
        <Button danger onClick={show} block icon={<DeleteOutlined />}>
          Удалить
        </Button>
      )}

      <Modal
        okText={"Удалить"}
        cancelText={"Отмена"}
        onOk={handleDelete}
        title={"Подтверждение"}
        onCancel={close}
        {...modalProps}
      >
        Вы уверены что хотите удалить {entityAccusative} «{name}»?
      </Modal>
    </>
  );
};
